import ACTIONS from "./MasterActionTypes";

const initialState = {
  getMasterListLoading: false,
  getMasterListResponse: null,
  postMasterLoading: false,
  postMasterResponse: null,
};

const MasterReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.GET_MASTER_LIST_REQUEST:
      return {
        ...state,
        getMasterListLoading: true,
      };
    case ACTIONS.GET_MASTER_LIST_RESPONSE:
      return {
        ...state,
        getMasterListLoading: false,
        getMasterListResponse: action.payload.data,
      };
    case ACTIONS.POST_MASTER_REQUEST:
    case ACTIONS.PUT_MASTER_REQUEST:
    case ACTIONS.PUT_STATUS_MASTER_REQUEST:
      return {
        ...state,
        postMasterLoading: true,
      };
    case ACTIONS.POST_MASTER_RESPONSE:
    case ACTIONS.PUT_MASTER_RESPONSE:
    case ACTIONS.PUT_STATUS_MASTER_RESPONSE:
      return {
        ...state,
        postMasterLoading: false,
        postMasterResponse: action.payload,
      };
    case ACTIONS.POST_MASTER_RESPONSE_CLEAR:
      return {
        ...state,
        postMasterResponse: null,
      };
    default:
      return state;
  }
};

export default MasterReducer;
